import { CommonBehaviours, CommonCompetencies, SalesProcessStrengths } from './Charts';
import { MotivationCharts } from './MotivationCharts';
import React, { useEffect, useState, memo } from 'react';
import B2BApi from '../../../B2bApi';
// import B2BApiService from '../../../B2bApiService';
import { Select } from "../../formComponents/Inputs";
import loading from '../../../assets/images/icons/loading.gif';
import * as Constants from "../../../constants"
import BubbleRadarChart from '../../reusableElementsComponents/BubbleRadarChart';
import { t } from '../../../content';
import { useLocale } from '../../../locale';

const KeyAnalytics = (props) => {
  useLocale();
  const coloumnOptions = [
    { id: 'Competency', title: 'Competency' },
    { id: 'Attitude', title: 'Attitude' }

  ]
  let [avgData, setAvgData] = useState({});
  //let [teamStrengthData, setTeamStrengthData] = useState();
  let [teamStrengthAllData, setTeamStrengthAllData] = useState();
  let [coloumn, setColoumn] = useState(coloumnOptions[0]);
  let [topBehaviours, setTopBehaviours] = useState([]);
  let [lowBehaviours, setLowBehaviours] = useState([]);
  let [commonComp, setCommonComp] = useState([]);
  let [topMotivations, setTopMotivations] = useState([]);
  let [lowMotivations, setLowMotivations] = useState([]);
  let [missingComp, setMissingComp] = useState([]);
  let [topAdept15Traits, setTopAdept15Traits] = useState([]);
  let [lowAdept15Traits, setLowAdept15Traits] = useState([]);
  let [salesData, setSalesData] = useState([]);
  // let [userData, setUserDataList] = useState();
  // let [columns, setColumns] = useState();

  useEffect(() => {
    if (props.tabActiveKey !== Constants.TAB_KEY_ANALYTICS_KEY) {
      return;
    }
    getAvgReportsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.tabActiveKey,
    props.selectedTeams,
    props.allTeams,
    props.is_pool_list,
  ]);

  const getAvgReportsData = () => {

    let obj = new B2BApi();
    let hash_list = [];

    if (props.selectedTeams?.length > 0) {
      hash_list = props.selectedTeams.map(x => x.hash);
    } else if (props.allTeams?.length > 0) {
      hash_list = props.allTeams.map(x => x.id || x.hash);
    }

    obj.apiCall('reports-average/', 'post', JSON.stringify({
      hash_list: hash_list,
      is_user_pool: props.is_pool_list || false,
    })).then((res) => {
      if (res.httpStatus !== 200 || res.json?.status === false || !res.json?.data) {
        return;
      }

      const responseData = res.json.data;
      setAvgData(responseData);
      setTeamStrengthAllData(responseData.team_strengths);

      const sortByAverage = (items) => (Array.isArray(items) ? items : []).slice().sort((a, b) => b.average - a.average);
      const behaviourPoints = sortByAverage(responseData.behaviour_points_average);
      const competencePoints = sortByAverage(responseData.competence_points_average);
      const motivationPoints = sortByAverage(responseData.motivation_points_average);
      const adept15Points = sortByAverage(responseData.adept15_points_average);

      setTopBehaviours(behaviourPoints.slice(0, 4));
      setLowBehaviours(behaviourPoints.slice(-4));

      setCommonComp(competencePoints.slice(0, 4));
      setMissingComp(competencePoints.slice(-4));

      setTopMotivations(motivationPoints.slice(0, 4));
      setLowMotivations(motivationPoints.slice(-4));

      setTopAdept15Traits(adept15Points.slice(0, 4));
      setLowAdept15Traits(adept15Points.slice(-4));

      setSalesData(responseData.sales_function_average?.Competency || {});
    }).catch((err) => {

    });
  }

  const onColumnChange = (e) => {
    coloumnOptions.forEach((col) => {
      if (e.target && e.target.value === col.id) {
        setColoumn(col);
        e.target.value === 'Competency'
          ? setSalesData(avgData.sales_function_average?.Competency || {})
          : setSalesData(avgData.sales_function_average?.Attitude || {})
      }
    });
  }

  const propsUpdate = (keyVal) => {
      props.activeKey(keyVal.toString())
      props = {...props, tabActiveKey: keyVal.toString() }

  }

  const teamStrengths = [
    "Service Orientation",
    "Analysis",
    "Innovation",
    "Planning and Organizing",
    "Implementation",
    "Coordination",
    "Co-operation",
    "Quality Control",
    "Promoting"
  ];

  return (
    <>
      {
        avgData?.behaviour_points_average !== undefined ?
            <div className="key-analytics-wrapper">

              <div className="analytics-section common-behaviours mar-25 bottom">
                <CommonBehaviours title={t('analytics.tabs.behaviours')} commonBehaviours={topBehaviours} missingBehaviours={lowBehaviours}/>
                <br/>
                <br/>
                <p className="individual-analytics-link" onClick={() => propsUpdate(1)}>{t('analytics.individuals')} {t('analytics.tabs.behaviours')} {' >>'}</p>
              </div>

              <div className="analytics-section common-competencies mar-25 bottom">
                <CommonCompetencies title={t('analytics.tabs.workStyles')} commonComp={commonComp} missingComp={missingComp}/>
                <br/>
                <br/>
                <p className="individual-analytics-link" onClick={() => propsUpdate(2)}>{t('analytics.individuals')} {t('analytics.tabs.workStyles')} {' >>'}</p>
              </div>

              <div className="analytics-section values mar-25 bottom">
                <MotivationCharts title={t('analytics.tabs.motivations')} topMotivations={topMotivations} lowMotivations={lowMotivations}/>
                <br/>
                <br/>
                <p className="individual-analytics-link" onClick={() => propsUpdate(3)}>{t('analytics.individuals')} {t('analytics.tabs.motivations')}{' >>'}</p>
              </div>

              <div className="analytics-section adept15 mar-25 bottom">
                <MotivationCharts title={t('analytics.adeptTraits')} topMotivations={topAdept15Traits} lowMotivations={lowAdept15Traits}/>
                <br/>
                <br/>
                <p className="individual-analytics-link" onClick={() => propsUpdate(4)}>{t('analytics.individuals')} {t('analytics.adeptTraits')}{' >>'}</p>
              </div>

              {props.companyCountry === Constants.COUNTRY_CODE_FINLAND && (
                <>
                  <div className="analytics-section sales-process-strengths mar-25 bottom">
                    <span className="salesProcessHeader">
                      <p className="l bold">{t('analytics.tabs.salesStrengths')}</p>
                      <Select
                          id={'coloums'}
                          label={t('analytics.strengthType')}
                          options={coloumnOptions}
                          handleChange={onColumnChange}
                          option={coloumn.title}
                          defaultValue={t('analytics.selectSalesStrengthType')}
                      />
                    </span>
                    <div className="wrapper" style={{minHeight: '430px'}}>
                      <SalesProcessStrengths salesData={salesData}/>
                    </div>
                    <br/>
                    <br/>
                    <p className="individual-analytics-link" onClick={() => propsUpdate(5)}>{t('analytics.individuals')} {t('analytics.tabs.salesStrengths')} {' >>'}</p>
                  </div>

                  <div className="analytics-section issing-competencies mar-25 bottom">
                    <p className="l bold">{t('analytics.tabs.teamStrengths')}</p>
                    <div className="wrapper" style={{minHeight: '400px', textAlign : 'center'}}>
                      {teamStrengthAllData && <BubbleRadarChart data={teamStrengthAllData} strengths={teamStrengths} />}
                    </div>
                    <br/>
                    <br/>
                    <p className="individual-analytics-link" onClick={() => propsUpdate(6)}>{t('analytics.individuals')} {t('analytics.tabs.teamStrengths')} {' >>'}</p>
                  </div>
                </>
              )}

            </div>
            :
            <div className='page-loading'>
              <img src={loading} alt={t('common.labels.loading')}/>
            </div>
      }
    </>
  )
}

export default memo(KeyAnalytics);